// import "./Tidycal.css";
// import Footer from "../Footer/footer";
// const TidyCalEmbed = () => {
//   return (
//     <div className="outer-tidical">
//       <div class="tidycal-container">
//         <iframe src="https://tidycal.com/michaeldimasciomedia/discovery-call"></iframe>
//       </div>
//       <Footer />
//     </div>
//   );
// };

// export default TidyCalEmbed;

import React, { useState } from "react";
import "./Tidycal.css";
import Footer from "../Footer/footer";

const TidyCalEmbed = () => {
  const [loading, setLoading] = useState(true);

  return (
    <>
      <div className="outer-tidical">
        {/* Loader */}
        {loading && (
          <div className="tidycal-loading">
            <div className="spinner" />
            {/* <p>Loading TidyCal...</p> */}
          </div>
        )}

        {/* Iframe */}
        <div
          className="tidycal-container"
          style={{ display: loading ? "none" : "block" }}
        >
          <iframe
            src="https://tidycal.com/michaeldimasciomedia/discovery-call"
            onLoad={() => setLoading(false)}
            title="TidyCal"
          />
        </div>
      </div>
      <Footer />
    </>
  );
};

export { TidyCalEmbed };
